<template>
  <div class="main-content">
    <div class="section-title">{{ title }}</div>
    <OptionList v-model="selected" :items="items" :perRow="perRow" />
  </div>
</template>

<script>
import OptionList from '@/components/web/proj/tongxin-demo/common/OptionList.vue'

export default {
  name: 'SelectionStep',
  components: { OptionList },
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    value: { type: [String, Number], default: null },
    perRow: { type: Number, default: 4 }
  },
  data() {
    return { selected: this.value }
  },
  watch: {
    value(v) { this.selected = v },
    selected(v) { this.$emit('input', v) }
  }
}
</script>

<style scoped>
.main-content { padding: 0; }

.section-title {
  font-size: 32px;
  font-weight: bold;
  color: #207868;
  margin: 0 0 24px;
  text-align: center;
  position: relative;
}
.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #207868, #2a9d8f);
  border-radius: 2px;
}

@media (min-width: 768px) {
  .section-title { margin-bottom: 30px; }
}
</style>
